module.exports = __webpack_public_path__ + "img/constructor_line.ef490d50.png";